import { useNavigate } from 'react-router-dom';

import { Bell, EyeOff, SquareSplitHorizontal } from 'lucide-react';
import { Action, Contracts } from '../../ManagedUsers';
import { NavBarV2 } from '../../Navbar';
import {
  useManagedUsersQuery,
  useNegotiationsNeedingResponseQuery,
  useNegotiationsWaitingResponseQuery
} from '../../data/useQueries';
import { archiveNegotiation } from 'src/api';

export function ManagedUsers() {
  const navigate = useNavigate();
  const needingResponse = useNegotiationsNeedingResponseQuery();
  const waitingResponse = useNegotiationsWaitingResponseQuery();
  const users = useManagedUsersQuery();
  const actions: Action[] = [
    {
      label: 'Review',
      onClick: (id) => {
        navigate(`/contracts/${id}`);
      },
      icon: <SquareSplitHorizontal size="16" />
    },
    // { label: 'Remind', onClick: (id) => {}, icon: <Bell size="16" /> },
    {
      label: 'Hide',
      onClick: async (id) => {
        await archiveNegotiation(id);
        needingResponse.refetch();
        waitingResponse.refetch();
      },
      icon: <EyeOff size="16" />
    }
  ];

  return (
    <>
      <NavBarV2 title="Managed Users" />
      <Contracts
        isLoading={users.isLoading}
        section={
          {
            contracts: [],
            title: 'Users',
            actions,
            users: users.data ?? []
          }
        }
      />
    </>
  );
}
